<template>
    <v-snackbar v-model="notification" :color="notificationColor">{{ notificationText }} <v-btn dark flat @click.native="notification = false">Close</v-btn></v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'notification',
  data () {
    return {
      notificationText: '',
      notificationColor: '',
      notification: false
    }
  },
  computed: {
    ...mapGetters({
      notifications: 'notifications'
    })
  },
  watch: {
    notifications (newNotification, oldNotification) {
      this.notification = false
      setTimeout(() => {
        this.notificationText = newNotification.text
        this.notificationColor = newNotification.color
        this.notification = true
      }, 250)
    }
  }
}
</script>


// WEBPACK FOOTER //
// notification.vue?758426b7